export enum UsersColumns {
	id = "Id",
	org = "Org",
	name = "Name",
	type = "Type",
	role = "Role",
	createdAt = "Created At",
	actions = "Actions",
}

export type AllowedUsersColumns =
	| UsersColumns.id
	| UsersColumns.org
	| UsersColumns.name
	| UsersColumns.type
	| UsersColumns.role
	| UsersColumns.createdAt
	| UsersColumns.actions
